import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
}

export function Card({
  children,
  header,
  footer,
  className,
  ...rest
}: CardProps) {
  return (
    <div className={cn(styles.card, className)} {...rest}>
      {header ? <div className={styles.cardHeader}>{header}</div> : null}
      <div className={styles.cardBody}>{children}</div>
      {footer ? <div className={styles.cardFooter}>{footer}</div> : null}
    </div>
  );
}
